<template>
  <div>
    <b-card class="ecommerce-card" no-body>
      <b-embed
        type="video"
        aspect="16by9"
        controls
        :src="item.url"
        allowfullscreen
        class="mt-1"
      />

      <b-card-body>
        <h6 class="item-name">{{ item.titulo }}</h6>

        <div class="prueba">
          {{ item.descripcion }}
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import {
  BCard,
  BCardBody,
  BEmbed,
  //   xxx,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardBody,
    BEmbed,
  },
  props: {
    item: Object,
  },
  setup(props, { emit }) {
    function eliminar(item) {
      emit('quitarLista', item)
    }
    return {
      eliminar,
    }
  },
}
</script>
